/*
 * Filename: form-control-configuration-panel.component.tsx
 * Description: Page section holds fields level configuration information
 */

import React, { Component, ReactNode, BaseSyntheticEvent } from 'react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { GridRowCustomVisibilityRuletModal } from '../row-actions/custom-row-visible-rule-modal';
import { CQAppStore } from '../../../../../store/cq-app-store';
import GridTemplateConfigurationController from '../../grid-template-config.controller';
import { AppliedRuleGridComponent } from '../../grid-applied-rule.component';
import { GridActionsReducer } from '../action-controller/grid-actions.reducer';
import { ActionMapperController } from '../action-controller/action-mapper';
import GridRightPaneComponentName from './grid-right-pane-component-name';

export class AddedCustomRowActionComponent
    extends Component<{ selectedTemplateName: string, action: any }, any> {

    private gridController: GridTemplateConfigurationController;
    private gridActionsReducer: GridActionsReducer;
    private vfPageComponentList: any;
    constructor(props: Readonly<{ selectedTemplateName: string, action: any }>) {
        super(props);
        this.gridController = new GridTemplateConfigurationController();
        this.gridActionsReducer = new GridActionsReducer();
        this.state = {
            isApplyRuleModalVisisble: false,
            label: '',
            isFormValid: false,
            actionType: '',
            componentNameSpace: '',
            popupType: false,
            isActionSaved: false,
            rowActionType: 'custom_row_action',
            isRuleApplied: false,
            visibilityRuleObj: {},
            name: '',
            visibilityRuleFields: [],
            isVisible: '',
            parentFields: [],
            additionalFieldsArray: [],
            isComponentNameSpaceEditable: false
        };
    }

    componentWillReceiveProps(nextProps: any) {
        const selectedAction = CQMasterDataStore.GridObject.selectedRowAction;
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements && ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const rowActions = gridObj && gridObj.hasOwnProperty('rowActions') ? gridObj.rowActions : {};
        if (nextProps && nextProps.action.name !== this.props.action.name) {
            if (rowActions && rowActions.hasOwnProperty(selectedAction.name)) {
                const ruleObject = { ...rowActions[selectedAction.name] }
                this.setState({
                    isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                    label: ruleObject.label,
                    isFormValid: ruleObject.isFormValid,
                    actionType: ruleObject.actionType,
                    componentNameSpace: ruleObject.componentNameSpace,
                    componentName: ruleObject.componentName,
                    popupType: ruleObject.popupType,
                    isActionSaved: ruleObject.isActionSaved,
                    isRuleApplied: ruleObject.isRuleApplied,
                    visibilityRuleObj: ruleObject.visibilityRuleObj,
                    name: ruleObject.name,
                    visibilityRuleFields: ruleObject.visibilityRuleFields,
                    isVisible: ruleObject.isVisible,
                    parentFields: ruleObject.parentFields,
                    additionalFieldsArray: ruleObject.additionalFieldsArray,
                });
            } else {
                this.setState({
                    isApplyRuleModalVisisble: false,
                    label: '',
                    isFormValid: false,
                    actionType: '',
                    componentNameSpace: '',
                    popupType: false,
                    isActionSaved: false,
                    isRuleApplied: false,
                    visibilityRuleObj: {},
                    name: '',
                    visibilityRuleFields: [],
                    isVisible: '',
                    parentFields: [],
                    additionalFieldsArray: [],
                    isComponentNameSpaceEditable: false
                });
            }
        }
    }

    componentDidMount() {
        const selectedAction = CQMasterDataStore.GridObject.selectedRowAction;
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements && ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const rowActions = gridObj && gridObj.hasOwnProperty('rowActions') ? gridObj.rowActions : {};

        if (rowActions && rowActions.hasOwnProperty(selectedAction.name)) {
            const ruleObject = { ...rowActions[selectedAction.name] }
            this.setState({
                isApplyRuleModalVisisble: ruleObject.isApplyRuleModalVisisble,
                label: ruleObject.label,
                isFormValid: ruleObject.isFormValid,
                actionType: ruleObject.actionType,
                componentNameSpace: ruleObject.componentNameSpace,
                componentName: ruleObject.componentName,
                popupType: ruleObject.popupType,
                isActionSaved: ruleObject.isActionSaved,
                rowActionType: 'custom_row_action',
                isRuleApplied: ruleObject.isRuleApplied,
                visibilityRuleObj: ruleObject.visibilityRuleObj,
                name: ruleObject.name,
                visibilityRuleFields: ruleObject.visibilityRuleFields,
                isVisible: ruleObject.isVisible,
                parentFields: ruleObject.parentFields,
                additionalFieldsArray: ruleObject.additionalFieldsArray,
            });
        }
    }

    public render(): ReactNode {
        const { ruleObject }: any = this.extractStoreData();
        return (
            <>
                <div className="slds-col config-sidebar full-height">
                    <div className="bg-white full-height slds-p-around_small">
                        <div className="slds-grid slds-grid_vertical full-height scroll-content">
                            <h2 className="slds-text-heading_small slds-m-bottom_medium">Row Actions</h2>
                            <dl className="slds-dl_horizontal slds-m-bottom_medium">
                                <dt className="slds-dl_horizontal__label">Custom Action</dt>
                            </dl>
                            <div className="slds-grid slds-grid_vertical full-height scroll-content">
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Name</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Name" value={this.state.name}
                                            onChange={this.onNameChange} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Label</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Label" value={this.state.label}
                                            onChange={this.onLabelChange} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Action Type</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" placeholder="Add Action Type" value={this.state.actionType}
                                            onChange={this.setActionType} className="slds-input" />
                                    </div>
                                </div>
                                <GridRightPaneComponentName
                                    isDisabled= {!this.state.actionType}
                                    onSelect= {this.onComponentNameChange}
                                    actionType= {this.state.actionType}
                                    key= "addedCustomRowAction"
                                    value= {this.state.componentName}
                                />
                                <div className="slds-form-element">
                                    <label className="slds-form-element__label">Component NameSpace</label>
                                    <div className="slds-form-element__control">
                                        <input type="text" id="" disabled={!this.state.isComponentNameSpaceEditable} placeholder="Add Component NameSpace" value={this.state.componentNameSpace}
                                            onChange={this.setComponentNameSpace} className="slds-input" />
                                    </div>
                                </div>
                                <div className="slds-form-element slds-grid slds-grid_vertical-align-center">
                                    <div className="slds-form-element__control">
                                        <input type="checkbox"
                                            disabled={this.state.actionType === 'VF_PAGE'}
                                            aria-describedby="checkbox-toggle-32"
                                            checked={this.state.popupType}
                                            onChange={this.setPopupType} />
                                    </div>
                                    <label className="slds-form-element__label">Popup Type</label>
                                </div>
                            </div>
                            {
                                this.state.isRuleApplied ? <AppliedRuleGridComponent ruleObject={ruleObject} toggleModalVisibility={this.toggleRuleModalVisibility} deleteRule={this.deleteRule} /> : <button className="slds-button slds-button_brand full-width slds-m-bottom_small"
                                    onClick={() => { this.toggleRuleModalVisibility(); }}>Add Rule</button>
                            }
                            <button disabled={!this.state.name || !this.state.isFormValid} className="slds-button slds-button_brand slds-m-bottom_small full-width"
                                onClick={this.updateCustomAction}>{ruleObject && ruleObject.hasOwnProperty('isActionSaved') && ruleObject.isActionSaved ? `Update Custom Action` : `Save Custom Action`}</button>

                            {
                                ruleObject && ruleObject.hasOwnProperty('isActionSaved') && ruleObject.isActionSaved && <button className="slds-button slds-button_brand full-width"
                                    onClick={() => this.deleteCustomAction()}>Delete</button>
                            }

                        </div>
                    </div>
                </div>
                {
                    this.state.isApplyRuleModalVisisble && <GridRowCustomVisibilityRuletModal
                        selectedTemplateName={this.props.selectedTemplateName}
                        toggleModalVisibility={this.toggleRuleModalVisibility}
                        ruleObject={ruleObject}
                        actionType={this.state.name}
                        updateVisibilityRuleObj={this.updateVisibilityRuleObj}
                    />
                }
            </>
        );
    }

    /**
     * @private
     * @memberof CustomRowActionComponent
     */
    private extractStoreData = () => {
        let ruleObject = {};
        const ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObj = ruleElements && ruleElements.hasOwnProperty('gridObject') ? ruleElements.gridObject : {};
        const rowActions = gridObj && gridObj.hasOwnProperty('rowActions') ? gridObj.rowActions : {};
        if (rowActions && rowActions.hasOwnProperty(this.state.name)) {
            ruleObject = rowActions[this.state.name];
        }
        return { ruleObject, gridObj };
    }

    public deleteRule = () => {
        const selectedRowAction = CQMasterDataStore.GridObject.selectedRowAction;
        this.gridActionsReducer.deleteViewModel(selectedRowAction.name, this.props.selectedTemplateName, 'rowActions');
        this.updateVisibilityRuleObj(false, {}, [], 'false', [], []);
        const outputConfig: any = CQMasterDataStore.OutputConfig;
        let rowFormRules = { ...outputConfig[this.props.selectedTemplateName].rowFormRules };
        if (rowFormRules.hasOwnProperty(this.state.label)) {
            delete rowFormRules[this.state.label]
        }
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'rowFormRules', rowFormRules)
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private toggleRuleModalVisibility = () => {
        this.setState({
            isApplyRuleModalVisisble: !this.state.isApplyRuleModalVisisble
        })
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onComponentNameChange = (addedVal: string, nameSpacePrefix: string) => {
        this.setState({
            componentName: addedVal,
            componentNameSpace: this.state.actionType === 'VF_PAGE'?
                                    nameSpacePrefix ? nameSpacePrefix+'__' : 'compliancequest__'
                                    :                        
                                    nameSpacePrefix ? '' : 'c-',
            isComponentNameSpaceEditable: false
        }, () => {
            this.isFormValid();
        });

    }

    public updateVisibilityRuleObj = (isRuleApplied: boolean, visibilityRuleObj: any, fields: any, isVisible: string, parentFields: [], additionalFieldsArray: any) => {
        this.setState({
            isRuleApplied: isRuleApplied,
            visibilityRuleObj: visibilityRuleObj,
            visibilityRuleFields: fields,
            isVisible,
            parentFields,
            additionalFieldsArray
        }, () => {
            this.isFormValid();
        });
    }

    private setActionType = (e: BaseSyntheticEvent) => {
        const actionType = e.target.value;
        const popupType = actionType === 'VF_PAGE' ? false : true;
        this.setState({
            actionType,
            popupType,
            componentNameSpace: popupType ? 'c__' : this.state.componentNameSpace,
            componentName: '',
        }, () => {
            this.isFormValid();
        })
    }

    private setPopupType = (e: BaseSyntheticEvent) => {
        this.setState({
            popupType: !this.state.popupType
        }, () => {
            if (!this.state.componentNameSpace && this.state.popupType) {
                this.setState({
                    componentNameSpace: 'c__',
                    isComponentNameSpaceEditable: false
                })
            }
            this.isFormValid();
        });
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private onLabelChange = (e: BaseSyntheticEvent) => {
        if (e.target.value !== '') {
            const enteredVal = e.target.value;
            this.setState({
                label: enteredVal
            }, () => {
                this.isFormValid();
            });
        }
    }

    private onNameChange = (e: BaseSyntheticEvent) => {
        if (e.target.value !== '') {
            const enteredVal = e.target.value;
            this.setState({
                name: enteredVal
            }, () => {
                this.isFormValid();
            });
        }
    }


    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private setComponentNameSpace = (e: BaseSyntheticEvent) => {
        if (e.target.value !== '') {
            const enteredVal = e.target.value;
            this.setState({
                componentNameSpace: enteredVal
            }, () => {
                this.isFormValid();
            });
        }
    }

    /**
     * @private
     * @memberof CustomHeaderActionComponent
     */
    private isFormValid = () => {
        if (!this.state.componentNameSpace || !this.state.actionType) {
            this.setState({
                isFormValid: false
            })
        } else {
            this.setState({
                isFormValid: true
            })
        }
        if (this.state.isRuleApplied) {
            this.setState({
                isFormValid: true
            })
        }
    }

    private deleteCustomAction = () => {
        this.gridController.resetRowCustomAction(this.state.name, this.props.selectedTemplateName);
    }

    private updateCustomAction = () => {
        CQAppStore.loader.setVisibility(true);
        if (this.state.isFormValid) {
            this.setState({
                isActionSaved: true
            }, () => {
                this.updateRuleElements()
                const actionObject: any = ActionMapperController[this.state.rowActionType].getControllerInstance(this.state);
                this.saveDataToStore(actionObject);
                this.saveToOrderingList(actionObject);
                setTimeout(() => { CQAppStore.loader.setVisibility(false); }, 2000);
            });
        }
    }

    private saveToOrderingList = (actionObject: any) => {
        let orderedRowAction = [...CQMasterDataStore.GridObject.orderedRowAction];
        if (!actionObject.actionJSON.hasOwnProperty('rowFormRules')) {
            const ifExist = orderedRowAction.map((orderedAction: any, index: number) => {
                let action = { ...orderedAction }
                if (action.actionJSON.hasOwnProperty('rowActions') && action.actionJSON.rowActions.name === this.state.name) {
                    orderedRowAction[index] = actionObject;
                    return true
                }
                return false;
            })
            if (!ifExist) {
                orderedRowAction.push(actionObject);
            }
            CQMasterDataStore.GridObject.updateGridField('orderedRowAction', orderedRowAction);
        } else {
            orderedRowAction.forEach((orderedAction: any, index: number) => {
                let action = { ...orderedAction }
                if (action.actionJSON.hasOwnProperty('rowActions') && action.actionJSON.rowActions.name === this.state.name) {
                    orderedRowAction.splice(index, 1);
                }
            });
            CQMasterDataStore.GridObject.updateGridField('orderedRowAction', orderedRowAction);
        }

    }

    private saveDataToStore = (actionObject: any) => {
        const outputConfig: any = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
        actionObject && Object.keys(actionObject.actionJSON).length && Object.keys(actionObject.actionJSON).map((objKey: string) => {
            if (objKey === 'rowFormRules') {
                const headerFormRules = { ...outputConfig.rowFormRules, ...actionObject.actionJSON[objKey] };
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, headerFormRules);
            } else if (objKey === 'rowActions') {
                let rowActions = [...outputConfig.rowActions];
                const ifExist = rowActions.map((action: any, index: number) => {
                    if (action.name === this.state.name) {
                        rowActions[index] = { ...actionObject.actionJSON[objKey] };
                        return true;
                    }
                    return false;
                })
                if (!ifExist) {
                    rowActions.push({ ...actionObject.actionJSON[objKey] })
                }
                CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, objKey, rowActions);
            }
        });
        const parentFields = [...outputConfig.parentFields, ...this.state.parentFields];
        if (parentFields.length) {
            const parentFieldsArray = Array.from(new Set(parentFields));
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'parentFields', parentFieldsArray);
        }
    }

    private updateRuleElements = () => {
        let ruleElementsObj: any = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        let gridObj = { ...ruleElementsObj.gridObject };
        let rowActions = { ...gridObj.rowActions };
        rowActions[this.state.name] = { ...rowActions[this.state.name], ...this.state };
        gridObj.rowActions = rowActions;
        ruleElementsObj.gridObject = gridObj;
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElementsObj);
    }
}

export const AddedCustomRowActionRootComponent = observer(
    AddedCustomRowActionComponent
);